import { selectIsGuest } from 'redux/db/reducers';
import {
	showAlertModal,
	showConfirmModal,
	showPromptModal,
	setActiveSceneId,
	setPlanPricingModalVisible,
	showMigrationModal,
} from 'redux/mode/actions';
import type {
	AlertModalOptions,
	ConfirmModalOptions,
	PromptModalOptions,
} from 'redux/mode/reducers';
import store from 'redux/store';
import { navigate } from 'utils';
import { trackEconomyAction } from 'analytics';
import { profile } from 'routes';

export const displayPromptModal = (options: PromptModalOptions) => {
	store.dispatch(showPromptModal(options));
};

export const displayConfirmModal = (options: ConfirmModalOptions) => {
	store.dispatch(showConfirmModal(options));
};

export const displayAlertModal = (options: AlertModalOptions) => {
	store.dispatch(showAlertModal(options));
};

export const displayPlanPricingModal = () => {
	store.dispatch(setPlanPricingModalVisible(true));
};

export const displayViewOnlyModal = () => {
	if (selectIsGuest(store.getState().db)) {
		displayPlanPricingModal();
		return;
	}

	displayAlertModal({
		title: "You're in view-only mode",
		description:
			"You can look around, but you'll need edit access to make changes. Ask the owner for edit access to start designing.",
		submitLabel: 'OK',
		onSubmit: () => {},
	});
};

export const displayUpgradeModal = (featureName: string) => {
	trackEconomyAction('feature_upgrade_modal_shown');

	displayConfirmModal({
		title: 'Upgrade Required',
		description: `${featureName} is available for Pro and Max subscribers. Upgrade to unlock this feature and more.`,
		cancelLabel: 'Close',
		submitLabel: 'Upgrade',
		onSubmit: () => {
			trackEconomyAction('upgrade_clicked');
			store.dispatch(setActiveSceneId(null));
			navigate(profile());
		},
	});
};

export const displayMigrationRequiredModal = (
	dsId: string,
	context: 'editor' | 'scene',
	sceneId?: string
) => {
	const state = store.getState();
	if (state.mode.migrationModal?.dsId === dsId) {
		return;
	}

	store.dispatch(showMigrationModal({ dsId, context, sceneId }));
};
